module.exports = __webpack_public_path__ + "media/images/lig/uxu-gallery/gallery-item-6-8b38162e437a6f9b535294f4ee050fd4.jpg";